// extracted by mini-css-extract-plugin
export default {"fragmentblog":"afa0e9279418f62757c0"};